export default {
  tags: 'Tags',
};
